import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    SHOW_IMAGE_INTERNAL_GALLERY,
    ShowImageInternalGallery
} from '../../../actions/imageEditor/internal/showImageInternalGallery';
import {
    ShowImageInternalGalleryError,
    showImageInternalGalleryErrorAction
} from '../../../actions/imageEditor/internal/showImageInternalGalleryError';
import {
    UpdateImagesInternalForGalleryEdit,
    updateImagesInternalForGalleryEditAction
} from '../../../actions/imageEditor/internal/updateImagesInternalForGalleryEdit';
import { ApiMethodExecutingError } from '../../../service/Errors';
import { EpicDeps } from '../../../service/StoreFactory';
import { ImageGalleryErrorsTypes } from '../../../typings/banners';
import { ErrorResponseType } from '../../../typings/common';
import { AdvType } from '../../../typings/domain';
import { State } from '../../../typings/state';

type EpicActions = UpdateImagesInternalForGalleryEdit | ShowImageInternalGalleryError;

export const openImageInternalGalleryEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SHOW_IMAGE_INTERNAL_GALLERY),
        mergeMap(
            (action: ShowImageInternalGallery): Observable<EpicActions> => {
                const state = store$.value;
                const { login } = state.commonData;
                const { bannerId, resourceId } = action;

                return from(deps.bannersDataProvider.getImagesForGallery(login, AdvType.INTERNAL)).pipe(
                    mergeMap(
                        (data): Observable<EpicActions> => {
                            if (data.length === 0) {
                                return of(
                                    showImageInternalGalleryErrorAction(bannerId, resourceId, [
                                        {
                                            code: ImageGalleryErrorsTypes.IMAGES_COUNT_NULL,
                                            path: '',
                                            params: null
                                        }
                                    ])
                                );
                            }

                            return of(updateImagesInternalForGalleryEditAction(bannerId, resourceId, data));
                        }
                    ),
                    catchError(
                        (error: ApiMethodExecutingError): Observable<ShowImageInternalGalleryError> => {
                            return of(
                                showImageInternalGalleryErrorAction(
                                    bannerId,
                                    resourceId,
                                    error.getType() !== ErrorResponseType.graphQL
                                        ? [
                                              {
                                                  code: ImageGalleryErrorsTypes.INTERNAL_ERROR,
                                                  path: '',
                                                  params: null
                                              }
                                          ]
                                        : error.getErrors()
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};
